import { render } from "./milestone-detail.view.vue?vue&type=template&id=3fa11d53&scoped=true&ts=true"
import script from "./milestone-detail.view.vue?vue&type=script&lang=ts"
export * from "./milestone-detail.view.vue?vue&type=script&lang=ts"

import "./milestone-detail.view.vue?vue&type=style&index=0&id=3fa11d53&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa11d53"]])

export default __exports__